import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable, startWith } from 'rxjs';
// import { VacanteResumen } from 'src/app/core/Interfaces/vacantes/vacante-resumen.interface';
import { VacantesResultados, Vacantes } from "src/app/core/Interfaces/vacantes/vacantes-resultado.interface";
import { CatalogosApiService } from 'src/app/core/services/catalogos-api.service';
import { HomeApiService } from 'src/app/core/services/home-api.service';
import { JobCardType } from '../components/job-card/job-card-type.enum';
import { getFormattedDates } from 'src/app/core/utils/date-utils';

const { fechaInicial, fechaFinal } = getFormattedDates(6);

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HomeComponent implements OnInit,AfterViewInit {
  @ViewChildren('fadeElement') fadeElements!: QueryList<ElementRef>;

  responsiveOptions;
  isLoading = true;
  emailSignup = new FormControl();
  jobOpenings: Vacantes[] = [];
  topJobs: Vacantes[] = [];
  buttons = ['remotebtn', 'todayjobbtn', 'halftimejobbtn'];
  activeButton: string = this.buttons[0]; // Por defecto el primer botón está activo
  JobCardType = JobCardType;
  bannerImageUrl: string = ''; // URL dinámica de la imagen del banner

  constructor(private translate: TranslateService,
    private homeApiService: HomeApiService,
    private cdr: ChangeDetectorRef) {
    this.translate.setDefaultLang('esmx'); // Idioma por defecto
    this.responsiveOptions = [{
      breakpoint: '1024px',
      numVisible: 1,
      numScroll: 3
    }];
  }

  ngAfterViewInit() {
    this.fadeElements.forEach((el) => {
      this.observeElementInViewport(el);
    });
  }

  observeElementInViewport(element: ElementRef) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target); // (opcional) para que no siga observando después de aparecer
        }
      });
    }, { threshold: 0.2 }); // 0.2 = el 20% del elemento debe estar visible
    observer.observe(element.nativeElement);
  }

  displayFn(option: string): string {
    return option ? option : '';
  }
  ngOnInit(): void {
    this.setBannerImageByDomain();
    this.getTopJobs();
    this.getJobOpenings('2');
  }

  setBannerImageByDomain(): void {
    const hostname = window.location.pathname;
    
    // Si es manpowergroup.com.mx, usar la imagen actual
    if (hostname.includes('/manpower')) {
      this.bannerImageUrl = '/assets/img/banner_manpower_home2.jpg';
    } else {
      // Default para manpower.com.mx u otros dominios
      this.bannerImageUrl = '/assets/img/home/banners_job_board_sinlogo-12.png';
    }
    
    this.cdr.detectChanges();
  }
  getTopJobs() {
    /*this.homeApiService.getVacantesPopulares().subscribe((data: VacantesResultados) => {
      this.isLoading = false;
      let _vacantesResultado: any = data.hits;
      let _vacantesHits: any = _vacantesResultado.hits;
      let _vacantes: Vacantes[] = _vacantesHits
      this.topJobs = _vacantes;
      this.cdr.detectChanges();
    });*/
  }

  getJobOpenings(tipo: string) {
    this.isLoading = true;
    this.jobOpenings = [];
    /*this.homeApiService.getVacantesPorFecha(fechaInicial, fechaFinal).subscribe((data: VacantesResultados) => {
      this.isLoading = false;
      let _vacantesResultado: any = data.hits;
      let _vacantesHits: any = _vacantesResultado.hits;
      let _vacantes: Vacantes[] = _vacantesHits
      this.jobOpenings = _vacantes;
      this.cdr.detectChanges();
    });*/
  }

  changeJobOpening(btn: string) {
    if (this.activeButton !== btn) {
      ['remotebtn', 'todayjobbtn', 'halftimejobbtn'];
      this.activeButton = btn;
      if (btn === 'remotebtn') {
        this.getJobOpenings('2');
      } else if (btn === 'todayjobbtn') {
        this.getJobOpenings('3');

      } else if (btn === 'halftimejobbtn') {
        this.getJobOpenings('4');

      }
    }
  }
}
